import React, { memo, useEffect, useCallback, useState} from 'react';
import TrackStepGroups from "components/groups/TrackStepGroups.js";
import TrackFrozenComponent from './TrackFrozenComponent.js';
import TrackFooter from './TrackFooter.js';
import StepsRow from './StepsRow.js';
import {connect} from 'react-redux';
import FrozenDragArea from 'components/freeze/FrozenDragArea.js';
import TrackLengthBar from '../track/TrackLengthBar.js';
import FrozenProgressComponent from 'components/freeze/FrozenProgressComponent.js';
import {TRACK_LENGTH_BUTTON, TRACK_REMOVE_STEPS_BUTTON} from 'constants/contextual-help.js';
import Colors from 'components/Colors.js';
import {FREEZE_BUTTON, TRACK_ADD_STEPS_BUTTON} from 'constants/contextual-help.js';
import StepsMap from '../track/StepsMap.js';
import LockButton from 'components/LockButton.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getStepsInChunks} from 'utils/getStepsInChunks.js';
import {getStepsInRow} from 'utils/getStepsInRow.js';
import {getBarLength} from 'utils/getBarLength.js';
import {trackPreparingToRecord, setSelectedPianoRollSteps} from 'actions/index.js';
import {
    mouseDown,
    setContextualHelp,
    setTrackFocused,
    setStepNumberDraggedTo,
    setSelectedSteps,
    setShowTrackEffects,
    setSelectorMode,
    setSidebarCollapsed,
    setTrackLengthMode,
    hideAllEffects,
    setStepsSelection,
    setSimilarSoundsToFind,
    setStepNumberDraggingFrom,
    setTrackToFreeze} from 'actions/index.js';
import StepData from 'pattern/StepData.js';
import Resolution from 'engine/Resolution.js';

const BASE_RESOLUTION = new Resolution(32, false);

const DEFAULT_STEP_DATA = new StepData();
const PART_LENGTH = 128;
const colors = new Colors();


const StepsContainer = memo(({
    isTrackFrozen,
    trackLengthMode,
    sequencerEngine,
    trackColor,
    track,
    id,
    partNumber,
    numberParts,
    resolution,
    isMini,
    show,
    isSelectedTrack,
    setTrackLengthMode,
    stepGroups,
    sequencerScale
}) => { 
    let className = "steps-container";
    if (isTrackFrozen) {
        className += " frozen";
    }
    
    let lengthModeButtonClass = "track-length-button";
    if (trackLengthMode) {
        lengthModeButtonClass += " selected";
        className += " track-length-mode";
    }

    let length = track.length;

    let stepsInRow = getStepsInRow(resolution);
    let stepsInChunks = getStepsInChunks(track, resolution);
    let minChunk = 0;
    if (length > PART_LENGTH) {
        minChunk = Math.floor(partNumber * stepsInChunks.length / numberParts);
        let maxChunk = Math.floor((partNumber + 1) * stepsInChunks.length / numberParts);
        stepsInChunks = stepsInChunks.filter((x, i) => i >= minChunk && i < maxChunk);
    }
    
    if (stepsInChunks[0] === undefined) {
        return (
            <div></div>
        );
    }
    let chunkSize = stepsInChunks[0].length;
    var barLength = getBarLength(resolution);

    if (isTrackFrozen) {
        stepsInChunks = [];
    }

    return (
        <div
          onMouseDown={isMini ? (e) => e.stopPropagation() : undefined}
          className={className}>
          <TrackStepGroups scale={sequencerScale} track={track}/>
          {!isMini && length > PART_LENGTH && !isTrackFrozen ?
           <StepsMap
             partNumber={partNumber}
             track={track}
             trackColor={trackColor}
             sequencerEngine={sequencerEngine}/> : ''}
          {stepsInChunks.map(
              (stepNumbers, chunk) =>
                  <StepsRow
                    isMini={isMini}
                    key={chunk}
                    // static data that does not change (mostly)
                    trackColor={trackColor}
                    sequencerEngine={sequencerEngine}
                    resolution={resolution}
                    show={show}
                    barLength={barLength}
                    isSelectedTrack={isSelectedTrack}
                    trackLengthMode={trackLengthMode}
                    id={id}
                    stepNumbers={stepNumbers}
                    stepsInRow={stepsInRow}
                    partNumber={isNaN(partNumber) ? 0 : partNumber} // which part number in step map (when len. > 4 bars)
                    chunk={chunk} // chunk number 
                    track={track}
                  />)}
          <TrackFrozenComponent
            track={track}
            trackColor={trackColor}
            isTrackFrozen={isTrackFrozen}/>
          <TrackFooter
            stepsInRow={stepsInRow}
            trackLengthMode={trackLengthMode}
            isSelectedTrack={isSelectedTrack}
            trackColor={trackColor}
            resolution={resolution}
            setTrackLengthMode={setTrackLengthMode}
            track={track}/>
        </div>);
});

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let currentGlobalStep = state.sequencer.currentGlobalStep[id] || 0;
    let tracksFrozen = state.tracks.tracksFrozen[props.track.subSequence.id] || {};
    let isTrackFrozen = tracksFrozen[props.track.id];
    let showParts = props.track.length > PART_LENGTH;
    let partNumber = undefined;
    let numberParts = undefined;
    if (showParts) {
        partNumber = Math.floor((currentGlobalStep % props.trackData.length) / 128);
        numberParts = props.track.length / PART_LENGTH;
        let showCursor = state.mix.selectedTrack == props.trackNumber;
        let cursorStep = props.sequencerEngine.cursor.getStep();
        if (showCursor && !props.sequencerEngine.playing) {
            partNumber = Math.floor(cursorStep / 128);
        }
    }

    let selection = state.steps.stepsSelection;
    return {
        numberParts,
        resolution: state.sequencer.displayResolution,
        partNumber,
        isTrackFrozen,
        trackLengthMode: state.tracks.trackLengthMode,
        stepsLength: state.tracks.trackStepIds[props.track.id] &&
            state.tracks.trackStepIds[props.track.id].length,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setTrackLengthMode: (mode) => dispatch(setTrackLengthMode(mode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepsContainer);
